module.exports = __webpack_public_path__ + "static/media/like.752215e4.png";